<template>
  <div class="carousel-container" @mouseenter="stopCarousel" @mouseleave="handleMouseLeave">
    <div
      class="carousel-slide"
      v-for="(item, index) in sortedResList"
      :key="index"
      :class="[item.class, { active: currentIndex === index }]"
    >
      <div v-if="item.type === 'video'">
        <video
          :src="item.url"
          controls
          muted
          :ref="'video-' + index"
          @play="onVideoPlay(index)"
          @ended="onVideoEnded(index)"
        ></video>
      </div>
      <img v-else :src="item.url" alt="resource" />
    </div>
    <div class="carousel-controls">
      <div class="carousel-btn" @click="prevSlide">
        <a-icon type="left" />
      </div>
      <div class="carousel-btn" @click="nextSlide">
        <a-icon type="right" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Slideshow',
  props: {
    resList: Array
  },
  data() {
    return {
      carouselInterval: null, // 轮播图自动切换的定时器
      currentIndex: 0, // 当前展示的资源索引
      sortedResList: [],
      interval: 3000 // 轮播间隔时间
    }
  },
  mounted() {
    this.deserializeSoftwareImage()
    this.startCarousel()
    // 检查第一个资源是否是视频
    if (this.sortedResList[0]?.type === 'video') {
      this.$nextTick(() => {
        const videoElement = this.$refs['video-0']?.[0]
        if (videoElement) {
          videoElement.play()
        }
      })
    }
  },
  methods: {
    // 反序列化软件图片和视频资源
    deserializeSoftwareImage() {
      // 视频优先排序
      this.resList.sort((a, b) => {
        if (a.type === 'video' && b.type !== 'video') {
          return -1
        } else if (a.type !== 'video' && b.type === 'video') {
          return 1
        }
        return 0
      })
      this.sortedResList = this.resList
      console.log('this.resList ----->', this.sortedResList)
    },
    // 开始自动轮播
    startCarousel() {
      console.log('开始自动播放 ----->', )
      this.carouselInterval = setInterval(() => {
        this.nextSlide()
      }, this.interval)
    },
    // 停止自动轮播
    stopCarousel() {
      clearInterval(this.carouselInterval)
      this.carouselInterval = null
    },
    // 切换到下一个资源
    nextSlide() {
      const slides = this.sortedResList
      const current = this.currentIndex
      const next = (current + 1) % slides.length

      // 暂停当前视频
      this.pauseCurrentVideo()

      // 设置当前幻灯片为left
      this.$set(slides[current], 'class', 'left')
      // 设置下一张幻灯片为active
      this.$set(slides[next], 'class', 'active')

      // 如果是视频则自动播放
      if (slides[next].type === 'video') {
        this.$nextTick(() => {
          const videoElement = this.$refs['video-' + this.currentIndex][0]
          console.log('videoElement ----->', videoElement)
          if (videoElement) {
            videoElement.play()
          }
        })
      }

      this.currentIndex = next
    },
    prevSlide() {
      const slides = this.sortedResList
      const current = this.currentIndex
      const prev = (current - 1 + slides.length) % slides.length

      // 暂停当前视频
      this.pauseCurrentVideo()

      // 设置当前幻灯片为right
      this.$set(slides[current], 'class', 'right')
      // 设置上一张幻灯片为active
      this.$set(slides[prev], 'class', 'active')

      this.currentIndex = prev

      // 如果是视频则自动播放
      if (slides[prev].type === 'video') {
        this.$nextTick(() => {
          const videoElement = this.$refs['video-' + this.currentIndex][0]
          console.log('videoElement ----->', videoElement)
          if (videoElement) {
            videoElement.play()
          }
        })
      }
    },
    // 暂停当前播放的视频
    pauseCurrentVideo() {
      // 获取当前资源
      const currentResource = this.sortedResList[this.currentIndex]
      // 如果是视频才处理
      if (currentResource.type === 'video') {
        // 找到对应的视频元素
        const videoElement = this.$refs['video-' + this.currentIndex][0]
        console.log('videoElement ----->', videoElement)
        if (videoElement) {
          videoElement.pause()
        }
      }
    },
    // 视频开始播放时的处理函数
    onVideoPlay(index) {
      console.log('视频开始播放 ----->')
      this.stopCarousel()
    },
    // 视频播放结束时的处理函数
    onVideoEnded(index) {
      console.log('视频结束播放 ----->')
      this.startCarousel()
      this.nextSlide()
    },
    handleMouseLeave() {
      console.log('this.sortedResList[this.currentIndex].type ----->', this.sortedResList[this.currentIndex].type)
      if (!(this.sortedResList[this.currentIndex].type === 'video')) {
        this.startCarousel()
      }
    }
  },
  beforeDestroy() {
    this.stopCarousel()
  }
}
</script>

<style lang="less" scoped>
// 轮播图样式
.carousel-container {
  position: relative;
  width: 100%;
  height: 800px;
  overflow: hidden;
  border-radius: 8px;
}

.carousel-slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: transform 0.5s ease-in-out;
  transform: translateX(100%);

  > div {
    width: 100%;
    height: 100%;
  }

  img,
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.carousel-slide.active {
  transform: translateX(0);
  z-index: 2;
}

.carousel-slide.left {
  transform: translateX(-100%);
  z-index: 1;
}

.carousel-slide.right {
  transform: translateX(100%);
  z-index: 1;
}
.carousel-controls {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  z-index: 3;
}

.carousel-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 1);
  }

  .anticon {
    font-size: 18px;
    color: #333;
  }
}

.carousel-slide.active {
  opacity: 1;
}
</style>
